module.exports = __webpack_public_path__ + "img/image_21.53f4fb04.png";